// Qué hace ESTE servidor con el reloj, dicho en una píldora de /admin/reloj (07-10).
//
// `GET /admin/reloj` trae `proceso` (backend/core/acciones_del_reloj.py, `estado_del_proceso`):
//   mueve_el_reloj                    si este servidor hace andar el reloj
//   despacha                          si además ejecuta lo que el reloj pide (envía sus correos)
//   envio_del_reloj                   el interruptor del envío (apagado en producción)
//   cuentas_en_la_lista_de_pruebas    cuántas cuentas reciben correos, o null si no hay lista
//   frase                             el detalle, ya redactado por el servidor
// Un reloj parado tiene que verse, no descubrirse porque no llega un correo.
//
// Lógica pura: sin React y sin red. Si `proceso` no viene (backend antiguo), devuelve null y
// la página no pinta nada.

const cuantasCuentas = (lista) => {
    if (Array.isArray(lista)) return lista.length;
    const n = Number(lista);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
};

/**
 * Devuelve null, o { tono, texto, detalle }:
 *   tono     'normal' (en marcha y envía) | 'apagado' (en marcha, sin envío) | 'aviso' (parado)
 *   texto    la frase de la píldora
 *   detalle  la frase del servidor, solo cuando el reloj está parado; null si no viene
 */
export const estadoDelProceso = (proceso) => {
    if (!proceso || typeof proceso !== 'object' || Array.isArray(proceso)) return null;
    if (!proceso.mueve_el_reloj) {
        const frase = typeof proceso.frase === 'string' ? proceso.frase.trim() : '';
        return { tono: 'aviso', texto: 'Este servidor no mueve el reloj: está parado', detalle: frase || null };
    }
    if (!proceso.despacha) {
        return { tono: 'apagado', texto: 'El reloj está en marcha; el envío de correos está apagado', detalle: null };
    }
    const n = cuantasCuentas(proceso.cuentas_en_la_lista_de_pruebas);
    const soloA = n ? `, solo a ${n === 1 ? '1 cuenta de prueba' : `${n} cuentas de prueba`}` : '';
    return { tono: 'normal', texto: `El reloj está en marcha y envía sus correos${soloA}`, detalle: null };
};
